import React, { useEffect } from 'react';
import { useStore } from '../../../../../../stores/root';
import styles from './styles.module.scss';
import { SpinnerSize, Stack } from '@fluentui/react';
import LoadingComponent from '../../../../../feedbacks/loading';
import Label from '../../../../../typography/label';
import GeneralService from '../../../../../../services/general';
import { IIncomeInvoiceResourceShortProps } from '../../../../../../props/finance/incomes/invoices/invoice';

type TotalIncomeInvoicePaidAmountCardProps = {
    style?: any;
    grow?: number | boolean | "inherit" | "initial" | "unset" | undefined;
    variant?: 'primary' | 'default';
    invoices?: IIncomeInvoiceResourceShortProps[];
}

const TotalIncomeInvoicePaidAmountCard: React.FC<TotalIncomeInvoicePaidAmountCardProps> = (props: TotalIncomeInvoicePaidAmountCardProps) => {
    const { banner } = useStore();
    const [paidAmount, setPaidAmount] = React.useState<number>();

    useEffect(() => {
        calculatePaidAmount();
    }, [props.invoices]);

    const calculatePaidAmount = () => {
        let totalAmount = 0;

        (props.invoices || []).forEach((invoice) => {
            totalAmount += Number(invoice.paid || '0');
        });

        setPaidAmount(totalAmount);
    }

    return <Stack grow={props.grow} tokens={{ childrenGap: 20 }} className={`${styles.card} ${styles.variant}`} style={props.style}>
        <Stack>
            <Label size={'small'}>Paid amount</Label>
        </Stack>
        <Stack>
            {!props.invoices ? <LoadingComponent labelPosition='right' label={'Retrieving ...'} spinnerPosition={'baseline'} size={SpinnerSize.small} /> : null}
            {props.invoices ? <>
                <Label className={'color-green'} size={'large'}>Rp. {GeneralService.getNumberWithSeparator(paidAmount + '')}</Label>
            </> : null}
        </Stack>
    </Stack>;
};

export default TotalIncomeInvoicePaidAmountCard;
